<template>
    <div class="header">
        <div class="logo">
          <router-link to="/">
            <span class="header-logo"></span>
            <span class="header-title">{{ title }} </span>
          </router-link>
        </div>
        <div class="right-menu">
          <div class="badge">
            <svg-icon icon-class="tip" />
          </div>
          <el-dropdown class="avatar-container right-menu-item hover-effect">
            <div class="avatar-wrapper">
              <svg-icon icon-class="user" class="user-icon"/>
              <span class="avatar-name">
                  {{cpy_name}}
              </span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <router-link :to="setting">
                <el-dropdown-item>我的账户</el-dropdown-item>
              </router-link>
              <el-dropdown-item divided  @click.native="logout">
                <span>
                  退出
                  <svg-icon icon-class="logout" />
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
    </div>
</template>

<script>
   import { mapGetters } from 'vuex'
    export default {
        name: "Header",
        computed: {
          ...mapGetters([
            'cpy_name',
            'customid'
          ]),
          setting(){
            return "/setting/" + this.customid;
          }
        },
        data(){
          return {
            title: "本源物联网-SIM卡连接管理子平台",
            logoimg: require('@/assets/iot_logo.png'),
            message: 9,
          }
        },
        methods: {
          async logout() {
            await this.$store.dispatch('user/logout');
            this.$router.push("/login");
          }
        }
    }
</script>

<style scoped lang="scss">
  .header {
    display: flex;
    height: 60px;
    width: 100%;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    .logo {
      margin-right: auto;
      box-sizing: border-box;
      .header-logo {
          display: inline-block;
          width: 42px;
          height: 42px;
          // background: url("../../assets/loginlogo.png") no-repeat center/cover;
          vertical-align: middle;
      }
      .header-title {
          color: #fff;
        vertical-align: middle;
      }
    }
    .right-menu {
      height: 100%;
      line-height: 60px;
      &:focus {
        outline: none;
      }
      .badge {
        display: inline-block;
        font-size: 24px;
        height: 100%;
        color: #ffffff;
        vertical-align: top;
        line-height: 60px;
      }
      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        &.hover-effect {
          cursor: pointer;
          transition: background .3s;
          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }
      .avatar-container {
        margin-right: 30px;
        .avatar-wrapper {
          position: relative;
          font-size: 14px;
          color: #ffffff;
          .avatar-name {
            font-size: 14px;
            margin-left: 8px;
            color: #ffffff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue